import { formatFileds } from "./format.fields.js";
import { userColors } from "./user.color.js";

const {
    formatDataFields,
    convertFieldData,
    getLocaleData,
    getCurrencySymbol,
    convertNumberFormat,
    convertToTimezone,
    convertCurrencyDataType,
    convertMonthsDataType,
    convertPercentDataType,
    convertDateDataType,
    convertGeneralDataType,
    dateToDuration,
    formatDateWithoutTime,
} = formatFileds;

/*
*   get user color based on userId
*/
const {getUserColor} = userColors;


export default {
    formatDataFields,
    convertFieldData,
    getLocaleData,
    getCurrencySymbol,
    convertNumberFormat,
    convertToTimezone,
    convertCurrencyDataType,
    convertMonthsDataType,
    convertPercentDataType,
    convertDateDataType,
    convertGeneralDataType,
    dateToDuration,
    formatDateWithoutTime,
    getUserColor
}

export {
    formatDataFields,
    convertFieldData,
    getLocaleData,
    getCurrencySymbol,
    convertNumberFormat,
    convertToTimezone,
    convertCurrencyDataType,
    convertMonthsDataType,
    convertPercentDataType,
    convertDateDataType,
    convertGeneralDataType,
    dateToDuration,
    formatDateWithoutTime,
    getUserColor
}